import React, { useState, useEffect, useRef, useCallback } from "react";
import { getAllUsers } from "../services/settings";
import { toastrError, toastrSuccess } from "../components/toastr";
import { QRCodeSVG } from "qrcode.react";
import { Clipboard } from "@capacitor/clipboard";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import Loader from "../components/UI/loader";

function PublicLink() {
  const [user, setUser] = useState();
  const [loading, setLoader] = useState(false);
  const email = localStorage.getItem("email");
  const qrRef = useRef(null);

  useEffect(() => {
    getAllUsers(setLoader, setUser, email);
  }, []);

  const currentUserData = user?.find((u) => u.email === email);
  const publicUrl = currentUserData
    ? `https://pazhanam.com/waitlessq/#/public/waitlist/${currentUserData.id}`
    : "";

  const handleCopyUrl = async () => {
    try {
      await Clipboard.write({ string: publicUrl });
      toastrSuccess("URL copied to clipboard!");
    } catch {
      toastrError("Could not copy URL");
    }
  };

  const handleDownloadQR = useCallback(async () => {
    if (!qrRef.current) return;
    const svg = qrRef.current.querySelector("svg");
    if (!svg) return;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    const pngPromise = new Promise((resolve) => {
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
    });
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
    const pngUrl = await pngPromise;

    if (Capacitor.isNativePlatform()) {
      try {
        const base64Data = pngUrl.split(",")[1];
        const savedFile = await Filesystem.writeFile({
          path: "waitlist-qr.png",
          data: base64Data,
          directory: Directory.Cache,
        });
        await Share.share({ title: "Waitlist QR Code", files: [savedFile.uri] });
      } catch {
        toastrError("Could not save QR code");
      }
    } else {
      const a = document.createElement("a");
      a.download = "waitlist-qr.png";
      a.href = pngUrl;
      a.click();
    }
  }, []);

  return (
    <div className="max-w-md mx-auto px-5 pt-6 pb-8">
      <h1 className="text-2xl font-bold text-gray-900">Public Waitlist</h1>
      <p className="text-sm text-gray-500 mt-1 mb-5">
        Share this QR or link so customers can see the live queue
      </p>

      {currentUserData ? (
        <>
          {/* QR code */}
          <div className="bg-white rounded-2xl shadow-card border border-gray-100 p-6 flex flex-col items-center mb-4">
            <div
              ref={qrRef}
              className="bg-white p-4 rounded-2xl border border-gray-100 mb-4"
            >
              <QRCodeSVG
                value={publicUrl}
                size={200}
                fgColor="#450696"
                bgColor="#ffffff"
                level="M"
              />
            </div>
            <p className="text-xs text-gray-500 mb-4 text-center">
              Ask customers to scan this to join or check their place in the queue
            </p>
            <button
              onClick={handleDownloadQR}
              className="w-full py-2.5 bg-white border border-gray-200 text-gray-700 text-sm font-semibold rounded-xl"
            >
              Download QR Code
            </button>
          </div>

          {/* URL */}
          <div className="bg-white rounded-2xl shadow-card border border-gray-100 p-5">
            <p className="text-xs font-semibold text-gray-500 mb-2">Page URL</p>
            <div className="bg-gray-50 rounded-xl px-3 py-2.5 mb-3">
              <p className="text-xs text-gray-500 break-all">{publicUrl}</p>
            </div>
            <button
              onClick={handleCopyUrl}
              className="w-full py-2.5 bg-primary text-white text-sm font-semibold rounded-xl"
            >
              Copy URL
            </button>
          </div>
        </>
      ) : (
        !loading && (
          <p className="text-sm text-gray-400 text-center py-10">
            Complete your profile setup first.
          </p>
        )
      )}

      {loading && <Loader loading={loading} />}
    </div>
  );
}

export default PublicLink;
